<mat-drawer-container class="main-sidenav-container">
    <mat-drawer mode="push" position="end" [(opened)]="showEditSidenav">
        <form [formGroup]="rulesetForm">
            <div fxLayout="column" class="main-sidenav-form-container">
                <h3>{{sideNavMode == 'editValuation' ? 'Edit your' : 'Add a new'}} ruleset</h3>
                <mat-form-field floatLabel="always">
                    <mat-label>Name</mat-label>
                    <input matInput type="text" formControlName="displayNameCtrl">
                </mat-form-field>
                <div fxLayout="row" fxLayoutAlign="center">
                    <button mat-raised-button color="accent" (click)="closeEditSidenav()">Cancel</button>&nbsp;
                    <button *ngIf="sideNavMode === 'editRuleset'" mat-raised-button color="primary"
                        [class.spinner]="addingRulset" (click)="saveEditSidenav()"
                        [disabled]="!rulesetForm.valid || addingRulset">{{addingRulset === true ? 'Updating...' :
                        'Update'}}</button>
                    <button *ngIf="sideNavMode !== 'editRuleset'" mat-raised-button color="primary"
                        [class.spinner]="addingRulset" (click)="saveEditSidenav()"
                        [disabled]="!rulesetForm.valid || addingRulset">{{addingRulset === true ? 'Adding...' :
                        'Add'}}</button>
                </div>
                <div class="side-nav-error-text">{{addRulesetError}}</div>
            </div>
        </form>
    </mat-drawer>
    <mat-drawer-content>
        <div fxLayout="column" fxLayoutAlign="center center" class="main-container">
            <h1>Bank Transaction Enrichment Rules</h1>
            <div class="instruction-text">
                Use this section to create custom rules here to add categories and tag to transactions downloaded from
                your
                bank.
            </div>
            <div *ngIf="isLoadingRulesets !== true">
                <div>
                    <table mat-table [dataSource]="rulesets">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Ruleset</th>
                            <td mat-cell *matCellDef="let ruleset">{{ruleset.DisplayName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="numberOfRules">
                            <th mat-header-cell *matHeaderCellDef>Number of Rules</th>
                            <td mat-cell *matCellDef="let ruleset">{{ruleset.Rules ? ruleset.Rules.length : '--' }}</td>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>
                            </th>
                            <td mat-cell *matCellDef="let ruleset">
                                <button mat-icon-button color="primary" [routerLink]="['./', ruleset.Id]" [state]="{'ruleset': ruleset}">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="onDeleteRulesetClick(ruleset.Id)" [class.spinner]="isDeletingId && isDeletingId === ruleset.Id" [disabled]="isDeletingId && isDeletingId === ruleset.Id">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="rulesetsColumnsDisplay"></tr>
                        <tr mat-row *matRowDef="let row; columns: rulesetsColumnsDisplay;"></tr>
                    </table>
                    <div *ngIf="errorMessage">
                        <p> {{errorMessage}}</p>
                    </div>
                </div>
                <button mat-fab color="primary" aria-label="Add new ruleset" class="main-fab--absolute"
                (click)="openSidenav('addRuleset')">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            <div *ngIf="isLoadingRulesets === true">
                Loading rulesets...
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>